"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Size = void 0;
var Size;
(function (Size) {
    Size["XXS"] = "20px";
    Size["XS"] = "24px";
    Size["S"] = "32px";
    Size["M"] = "40px";
    Size["L"] = "48px";
    Size["XL"] = "56px";
})(Size || (exports.Size = Size = {}));
//# sourceMappingURL=Size.js.map